(function initGiftAutoMarkGift() {
  const config = window.giftAutoMarkGift;
  if (!config || !config.klydogreetVariantId) return;

  const KLYDOGREET_VARIANT_ID = Number(config.klydogreetVariantId);
  const KLYDOGREET_HANDLE = "klydogreet";
  const CART_URL = (window.routes && window.routes.cart_url) || "/cart";

  let isHandlingSubmit = false;
  let passThroughNextSubmit = false;

  const readLineItemProperties = (form) => {
    const properties = {};
    form.querySelectorAll('[name^="properties["]').forEach((field) => {
      if ((field.type === "checkbox" || field.type === "radio") && !field.checked) return;
      const match = field.name.match(/^properties\[(.+)\]$/);
      if (match) properties[match[1]] = field.value;
    });
    return properties;
  };

  // Best-effort: let Dawn's own listeners (analytics, cart bubble, etc.) know a
  // cart change happened, since we bypassed its product-form. Swallow subscriber
  // errors so a bad subscriber can't abort our redirect / trigger a double add.
  const publishCartUpdate = (cartData) => {
    try {
      if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: "gift-auto-mark-gift", cartData });
      }
    } catch (error) {
      console.warn("[gift-auto-mark-gift] cartUpdate subscriber error", error);
    }
  };

  // Hand the submit back to Dawn's product-form so the user gets its normal
  // flow (validation, sold-out errors, redirect) whenever we can't/shouldn't
  // take over. The passthrough flag makes our capture listener ignore the
  // re-dispatched event exactly once.
  const fallBackToNativeSubmit = (form) => {
    passThroughNextSubmit = true;
    if (typeof form.requestSubmit === "function") {
      form.requestSubmit();
    } else {
      passThroughNextSubmit = false;
      form.submit();
    }
  };

  // Dawn's product-form adds only the line the form carries, leaving no chance
  // to attach the Klydogreet. Intercepting here adds the Klydo and the
  // Klydogreet together, so the gift toggle is already on by the time the cart
  // is shown.
  const handleGiftPageSubmit = async (submitEvent) => {
    const form = submitEvent.target;
    if (!form.closest || !form.closest("product-form")) return;

    if (passThroughNextSubmit) {
      passThroughNextSubmit = false;
      return;
    }

    submitEvent.preventDefault();
    submitEvent.stopPropagation();

    if (isHandlingSubmit) return;
    isHandlingSubmit = true;

    const variantInput = form.querySelector('[name="id"]');
    const quantityInput = form.querySelector('[name="quantity"]');
    const variantId = variantInput ? Number(variantInput.value) : NaN;
    const quantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;

    // Nothing to add, or this form is adding the Klydogreet itself — let Dawn run.
    if (!variantId || variantId === KLYDOGREET_VARIANT_ID) {
      isHandlingSubmit = false;
      fallBackToNativeSubmit(form);
      return;
    }

    const klydoItem = { id: variantId, quantity };
    const properties = readLineItemProperties(form);
    if (Object.keys(properties).length) klydoItem.properties = properties;
    const items = [klydoItem];

    // Attach the Klydogreet unless it's already in the cart. This check is
    // best-effort — a failure here must NOT block adding the Klydo, so it has
    // its own try/catch and we default to attaching the gift on error.
    let alreadyHasKlydogreet = false;
    try {
      const cartResponse = await fetch("/cart.js");
      const cart = await cartResponse.json();
      alreadyHasKlydogreet = cart.items.some((item) => item.handle === KLYDOGREET_HANDLE);
    } catch (error) {
      console.warn("[gift-auto-mark-gift] cart check failed; attaching gift anyway", error);
    }
    if (!alreadyHasKlydogreet) items.push({ id: KLYDOGREET_VARIANT_ID, quantity: 1 });

    // With the drawer in play the add can be shown in place, so ask for its
    // sections and hand it the response — the gift toggle comes back ticked on
    // its own, since the Klydogreet is now a line in the cart. Without a drawer
    // there is nowhere to show it, so the redirect stands.
    const cartDrawer = document.querySelector("cart-drawer");
    const requestBody = { items: items };
    let addedCart = null;
    if (cartDrawer) {
      requestBody.sections = cartDrawer
        .getSectionsToRender()
        .map((section) => section.id);
      requestBody.sections_url = window.location.pathname;
    }

    try {
      const addResponse = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestBody),
      });
      if (!addResponse.ok) throw new Error(`/cart/add.js failed (${addResponse.status})`);

      addedCart = await addResponse.json();
    } catch (error) {
      // Real add failure (e.g. sold out) — hand back to Dawn so the user gets
      // its error UI instead of a dead button.
      console.error("[gift-auto-mark-gift]", error);
      isHandlingSubmit = false;
      fallBackToNativeSubmit(form);
      return;
    }

    // Past this point the add has gone through, so nothing may hand the submit
    // back to Dawn — that would add the whole lot a second time. A drawer that
    // fails to render falls back to the cart page instead.
    publishCartUpdate(addedCart);
    isHandlingSubmit = false;

    if (!cartDrawer) {
      window.location = CART_URL;
      return;
    }

    try {
      cartDrawer.renderContents(addedCart);
    } catch (error) {
      console.error("[gift-auto-mark-gift] drawer render failed:", error);
      window.location = CART_URL;
    }
  };

  document.addEventListener("submit", handleGiftPageSubmit, true);
})();
